import type { ReactNode } from "react";

export function ListaMobile({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`divide-y divide-neutral-100 lg:hidden ${className}`}>
      {children}
    </div>
  );
}

export function TabelaDesktop({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`hidden overflow-x-auto lg:block ${className}`}>
      {children}
    </div>
  );
}

export function CardMetricas({ children }: { children: ReactNode }) {
  return (
    <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-2">{children}</dl>
  );
}

export function CardMetrica({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`min-w-0 ${className ?? ""}`}>
      <dt className="text-[11px] font-medium uppercase tracking-wide text-neutral-400">
        {label}
      </dt>
      <dd className="mt-0.5 break-words text-sm font-semibold tabular-nums text-neutral-800">
        {children}
      </dd>
    </div>
  );
}

export function CabecalhoUndMobile({
  undNome,
  count,
  singular = "item",
  plural = "itens",
}: {
  undNome: string;
  count: number;
  singular?: string;
  plural?: string;
}) {
  return (
    <p className="bg-neutral-100 px-3 py-2 text-xs font-bold uppercase tracking-wide text-neutral-700">
      Unidade {undNome}
      <span className="ml-2 font-medium normal-case text-neutral-500">
        {count} {count === 1 ? singular : plural}
      </span>
    </p>
  );
}
